import { compose, map, sortBy, pick } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createOptionsSelector } from '@mews-commander/utils';
import { getCultures as getCulturesSelector } from '@mews-commander/core/legacy-globalization';

export const getCultures = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getCulturesSelector,
    compose(sortBy('code'), map(pick(['code', 'englishName'])))
);

export const getCultureOptions = createOptionsSelector(getCultures, { value: 'code', label: 'englishName' });
